package kz.dentalcrm.app.screens.quick_replies.add.mvi

import kz.dentalcrm.app.core.base.ViewEvent

sealed interface AddQuickReplyViewEvent : ViewEvent {
    data class AddQuickReply(val message: String) : AddQuickReplyViewEvent
    data object Reset : AddQuickReplyViewEvent
}
